var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKickGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3H10.25V6.77778H12V4.88889H13.75V3H19V8.66667H17.25V10.5555H15.5V12.4445H17.25V14.3333H19V20H13.75V18.1111H12V16.2222H10.25V20H5V3Z",
    fill: "url(#paint0_linear_2050_11281)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2050_11281",
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30AC72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60C946"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKickGreen);
export default __webpack_public_path__ + "static/media/kickGreen.2f43aaa79c1a2b4ae145a46cb3063e81.svg";
export { ForwardRef as ReactComponent };